import { getRemainingTimeTexts } from '../../utils/index';
import { useProject } from '../project-hooks/useProject';
import styles from './remaining-time.module.less';

const RemainingTime = ({ titleClass, numberLabelClass, labelClass, large, showDateTimeWithGeneralText }) => {
    const project = useProject();

    const remainingTimeTexts = getRemainingTimeTexts(project);

    if (remainingTimeTexts.generalText) {
        return (
            <div className={titleClass}>
                <span className={labelClass} suppressHydrationWarning>
                    {remainingTimeTexts.generalText}{' '}
                    {showDateTimeWithGeneralText && remainingTimeTexts.datetime ? remainingTimeTexts.datetime : ''}
                </span>
            </div>
        );
    }

    if (large) {
        return (
            <div className={titleClass}>
                <span className={numberLabelClass} suppressHydrationWarning>
                    {remainingTimeTexts.time}
                </span>
                <span className={labelClass} suppressHydrationWarning>
                    {remainingTimeTexts.timeText}
                </span>
            </div>
        );
    }

    return (
        <span className={styles.remainingTime} suppressHydrationWarning>
            <span className={styles.time}>{remainingTimeTexts.time}</span> {remainingTimeTexts.timeText}
        </span>
    );
};
export default RemainingTime;
